/**
 * Chart mutation observers - monitor SVG changes for label updates
 */

import { addCircleLabels } from '../labels.js';
import { restoreHighlights } from '../search.js';
import { showMyRolesActive } from '../state.js';

/**
 * Setup SVG mutation observer to reapply labels on transform changes
 */
export function setupSvgObserver(chartElement: HTMLElement): void {
    const svg = chartElement.querySelector('svg');
    if (!svg) return;

    const observer = new MutationObserver(() => {
        addCircleLabels();
        restoreHighlights();
        
        // Reapply my roles highlighting if active
        if (showMyRolesActive && typeof (window as any).reapplyMyRolesHighlight === 'function') {
            (window as any).reapplyMyRolesHighlight();
        }
    });

    observer.observe(svg, {
        attributes: true,
        attributeFilter: ['transform'],
        subtree: true
    });
}
